import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { AttendedECUModel } from '../../models/attended-ECU.model';
import { getEcusForModelSelector } from '../../store/selectors/get-ecus-for-model/get-ecus-for-model.selector';
import { getEcusByModel } from '../../thunk/get-ecus-by-model.thunk';

export const useGetEcusForModel = (modelId?: number): AttendedECUModel[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (modelId) {
      dispatch(getEcusByModel(modelId));
    }
  }, [modelId]);

  return useAppSelector(getEcusForModelSelector);
};
